import { Controller } from "remult";

@Controller("population-methods")
export class PopulationMethods {}






